import React, { useState, useEffect } from 'react';

import { 
    DashboardLayout, GeneralTable, 
    Button, AlertMessage, SubmenuTooltip, 
    MoreButton, GeneralModal, Toaster, ConfirmationModal
} from "components";
import UpdateClient from "./updateClient/UpdateClient";
import UpdateClientModal from "./updateClient/UpdateClientModal";

import { func_validation, getTotalCountFromHeader } from 'functions';
import { clientRegistrationColumns } from "./clientRegistrationColumns";

import ic_add_new_client from 'assets/images/ic_add_new_user.svg';
import ic_edit from "assets/images/ic_edit.svg";
import ic_delete from 'assets/images/ic_delete_invoices.svg';

import "assets/scss/distributorPortal/modules/clientRegistration/clientRegistration.scss";



export default function ClientRegistrationPresentation(props) {
    const { 
        getClientList_requesting, getClientList_status,
        clientList, clientListHeader,

        addClient_requesting, addClient_status,
        updateClient_requesting, updateClient_status,
        deleteClient_requesting, deleteClient_status,

        isClientRecordUpdatedSuccessfully
    } = props;

    let clientList_validated = func_validation.isArrayNotEmpty(clientList)? clientList: [];

    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isModalVisible_updateClient, setIsModalVisible_updateClient] = useState(false);
    const [isModalVisible_deleteClient, setIsModalVisible_deleteClient] = useState(false);
    const [isEditingClient, setIsEditingClient] = useState();
    const [selectedClients, setSelectedClients] = useState([]);
    
    const [
        alertMsg, setAlertMsg,
        isAlertMsgVisible, setIsAlertMsgVisible
    ] = useAlertMessage(props);

    function handleUpdateClientModal(isEditing) {
        setIsModalVisible_updateClient(true);
        setIsEditingClient(isEditing);
    }

    function handleDeleteClient() {
        if (func_validation.isFunction(props.deleteClient))
            props.deleteClient(selectedClients);
    }

    return (
        <React.Fragment>
            {(!isFormVisible)? (
                <DashboardLayout
                    className={"distributorPortal-clientRegistration"}
                    headerTitle={"Registration"}

                    bodyClassName={"distributorPortal-clientRegistration-body"}
                    body={(
                        <>
                            {/* Update Client Modals */}
                            <UpdateClientModal
                                {...props}
                                isEditing={isEditingClient}
                                selectedClients={func_validation.isArrayNotEmpty(selectedClients)? selectedClients[0]:{}}
                                handleUpdateClientModal={() => props.handleUpdateClientModal(false)}
                                isModalVisible={isModalVisible_updateClient}
                                updateModalVisibility={setIsModalVisible_updateClient}
                                addClient_requesting={addClient_requesting}
                                addClient_status={addClient_status}
                            />

                            {/* Delete Client Modal */}
                            <ConfirmationModal
                                description={"The selected client(s) will be deleted."}
                                cancelButtonText={"Cancel"}
                                confirmButtonText={"Confirm"}
                                isModalVisible={isModalVisible_deleteClient}
                                updateParentState={setIsModalVisible_deleteClient}
                                handleOnConfirm={handleDeleteClient}
                                isActionLoading={deleteClient_requesting}
                                isConfirmSuccessful={deleteClient_status}
                            />

                            {/* Table */}
                            <GeneralTable
                                className={"distributorPortal-clientRegistration-table"}
                                columns={clientRegistrationColumns.getColumns()}
                                data={clientList_validated}
                                minRows={10}

                                getTableData={props.getClientList}

                                isTableRefreshRequired={isClientRecordUpdatedSuccessfully}

                                outerTableHeader={(props) => {
                                    const { selectedRows: selectedClients } = props;

                                    return (
                                        <React.Fragment>
                                            {/* Alert Error Messages */}
                                            <AlertMessage
                                                message={alertMsg}
                                                isVisible={isAlertMsgVisible}
                                                toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
                                            />

                                            <div className={"distributorPortal-clientRegistration-table-header d-flex align-items-center justify-content-between "}>
                                                <div className={"distributorPortal-clientRegistration-tableHeader-title tableHeaderTitle "}>
                                                    Client List
                                                </div>

                                                <div className={"distributorPortal-clientRegistration-tableHeader-action d-flex align-items-center"}>
                                                    
                                                    <div className={"distributorPortal-clientRegistration-tableHeaderAction-mainActionWrapper"}>
                                                        <Button
                                                            className={"distributorPortal-clientRegistration-tableHeaderAction-mainAction tableHeaderButtonPadding d-flex align-items-center"}
                                                            handleOnClick={() => { handleUpdateClientModal(); }}

                                                            isDecoration_primaryTransparent
                                                        >
                                                            <React.Fragment>
                                                                <img
                                                                    className={"distributorPortal-clientRegistration-tableHeaderAction-icon"}
                                                                    src={ic_add_new_client}
                                                                    alt={"Register client icon"}
                                                                />

                                                                <span className={"distributorPortal-clientRegistration-tableHeaderAction-text tableHeaderButtonText "}>Register Client</span>
                                                            </React.Fragment>
                                                        </Button>
                                                    </div>

                                                    {/* <SubmenuTooltip
                                                        buttonClassName={""}
                                                        menuItems={
                                                            [
                                                                {
                                                                    icon: ic_edit,
                                                                    label: "Edit Client",
                                                                    onClick: () => { 
                                                                        if (func_validation.isArrayNotEmpty(selectedClients) &&
                                                                            func_validation.isArrayLengthEqual(selectedClients, 1)) {
                                                                            handleUpdateClientModal(true);
                                                                            setSelectedClients(selectedClients);
                                                                        }
                                                                        else if (func_validation.isArrayEmpty(selectedClients))
                                                                            Toaster({ type: "info", msg: "Please select a client" });
                                                                        else Toaster({ type: "info", msg: "Please select only 1 client" });
                                                                    },
                                                                },
                                                                {
                                                                    icon: ic_delete,
                                                                    label: "Remove Client",
                                                                    onClick: () => { 
                                                                        if (func_validation.isArrayNotEmpty(selectedClients)) {
                                                                            setIsModalVisible_deleteClient(true);
                                                                            setSelectedClients(selectedClients);
                                                                        }
                                                                        else {
                                                                            Toaster({
                                                                                type: "info",
                                                                                msg: "Please select at least 1 client.",
                                                                            });
                                                                        }
                                                                    },
                                                                },
                                                            ]
                                                        }
                                                    >
                                                        <MoreButton
                                                            className={"distributorPortal-clientRegistration-tableHeaderAction-moreActions"}
                                                            iconClassName={"distributorPortal-clientRegistration-tableHeaderMoreAction-icon"}
                                                        />
                                                    </SubmenuTooltip> */}
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                }}

                                isTableDataLoading={getClientList_requesting}

                                isUsingPagination
                                totalRecords={getTotalCountFromHeader(clientListHeader)}

                                // isCheckboxRequired 
                                isCheckboxColumnFirst
                                isExpanderRequired
                                isColumnResizeable
                                isTableOddRowsDarken isAllColumnWidthEqual
                            />
                        </>
                    )}
                />
            ):(
                <UpdateClient
                    isEditing={isEditingClient}
                />
            )}
        </React.Fragment>
    );
}

function useAlertMessage(props) {
    const { 
        addUser_requesting, addUser_status,
        addUser_errorMsg,
        
        updateUser_requesting, updateUser_status,
        updateUser_errorMsg,

        deleteUser_requesting, deleteUser_status,
        deleteUser_errorMsg,
    } = props;

    // States
    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    // Error Messages
    function updateErrorMsg(msg) {
        if (func_validation.isStringTrimNotEmpty(msg)) {
            let alertMsg_new = func_validation.cloneArray(alertMsg);
            let index = func_validation.getArrayLength(alertMsg_new, 0);
    
            alertMsg_new.push(<p key={index}>{msg}</p>);
            setAlertMsg(alertMsg_new);
        }
    } 
    useEffect(() => {
        updateErrorMsg(addUser_errorMsg);
    }, [addUser_errorMsg]);
    useEffect(() => {
        updateErrorMsg(updateUser_errorMsg);
    }, [updateUser_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deleteUser_errorMsg);
    }, [deleteUser_errorMsg]);

    return [
        alertMsg, setAlertMsg,
        isAlertMsgVisible,
        setIsAlertMsgVisible,
    ]
}